import Heading from './Heading'
export default Heading



// WEBPACK FOOTER //
// ./src/index.js